<ng-container *ngIf="displayForm">
  <ng-container [ngTemplateOutlet]="lineItemForm"></ng-container>
</ng-container>

<ng-container *ngIf="isView">
  <ng-container [ngTemplateOutlet]="lineItem"></ng-container>
</ng-container>

<ng-template #lineItemForm>
  <div class="row">
    <div class="col-12 mb-3">
      <browse-products
        (objProductSelected)="addLineItem($event, true)"
        [bLabor]="false"
        [bSales]="false"
        [bAllowCustom]="false"
      ></browse-products>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="mt-3">
        <table class="table border rounded" width="100%">
          <thead>
            <tr>
              <th scope="col" width="15%" class="fs-12 text-center">{{ 'name' | translate }}</th>
              <th scope="col" width="25%" class="fs-12 text-center">{{ 'description' | translate }}</th>
              <th scope="col" width="15%" class="fs-12 text-center">{{ 'buy_price' | translate }}</th>
              <th scope="col" width="15%" class="fs-12 text-center">{{ 'unit_price' | translate }}</th>
              <th scope="col" width="15%" class="fs-12 text-center">{{ 'contract_unit_price' | translate }}</th>
              <th scope="col" width="5%" class="fs-12 text-center">{{ 'action' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="arLineItems.length; else noAddedItems">
              <ng-container *ngFor="let line_item of arLineItems; index as lineItemIndex">
                <ng-container *ngIf="line_item.action != 'delete'">
                  <tr>
                    <td width="15%" class="truncate">
                      <span matTooltip="{{ 'name' | translate }}: {{ line_item.name | placeholdWithString }} ({{ line_item.item_code | placeholdWithString }})">
                        <fa-icon [icon]="['far', line_item.asset_type_id ? 'wrench' : 'box-open']"></fa-icon>
                        {{ line_item.name | placeholdWithString }} ({{ line_item.item_code | placeholdWithString }})
                      </span>
                    </td>
                    <td width="25%" class="truncate">
                      <span matTooltip="{{ 'description' | translate }}: {{ line_item.description | placeholdWithString }}">
                        {{ line_item.description | truncate | placeholdWithString }}
                      </span>
                    </td>
                    <td width="15%" class="text-center">
                      <span matTooltip="{{ 'buy_price' | translate }}: {{ line_item.item_unit_cost | currency }}">
                        {{ line_item.item_unit_cost | currency }}
                      </span>
                    </td>
                    <td width="15%" class="text-center">
                      <span matTooltip="{{ 'unit_price' | translate }}: {{ line_item.item_unit_price | currency}}">
                        {{ line_item.item_unit_price | currency}}
                      </span>
                    </td>
                    <td width="15%">
                      <fc-currency-input
                        [places]="4"
                        [(ngModel)]="line_item.contract_unit_price"
                        [nonNegative]="true"
                        (ngModelChange)="onChangeUnitPrice(line_item)"
                      ></fc-currency-input>
                    </td>
                    <td width="5%" class="text-center">
                      <a class="pl-1 pr-1 pb-2 pt-2 cursor-pointer" (click)="removeLineItem(line_item, lineItemIndex)">
                        <fa-icon
                          matTooltipClass="tooltip-space"
                          matTooltip="{{ 'remove' | translate }}"
                          class="text-danger"
                          [icon]="['fas', 'trash-alt']">
                        </fa-icon>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #noAddedItems>
              <tr>
                <td colspan="6" class="text-center">
                    {{ 'no_available_items' | translate }}
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lineItem>
  <table class="table table-layout-fixed mb-0 record-texts fs-11" width="100%">
    <thead>
      <tr>
        <th scope="col" width="20%" class="fs-12 text-center">{{ 'name' | translate }}</th>
        <th scope="col" width="26%" class="fs-12 text-center">{{ 'description' | translate }}</th>
        <th scope="col" width="12%" class="fs-12 text-center">{{ 'buy_price' | translate }}</th>
        <th scope="col" width="12%" class="fs-12 text-center">{{ 'unit_price' | translate }}</th>
        <th scope="col" width="20%" class="fs-12 text-center">{{ 'contract_unit_price' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="arExistingLineItems.length; else noRecordFound">
        <ng-container *ngFor="let line_item of arExistingLineItems; index as lineItemIndex">
          <tr>
            <td width="15%" class="truncate">
              <span matTooltip="{{ 'name' | translate }}: {{ line_item.name }} ({{ line_item.item_code }})">
                <fa-icon [icon]="['far', line_item.asset_type_id ? 'wrench' : 'box-open']"></fa-icon>
                {{ line_item.name }} ({{ line_item.item_code }})
              </span>
            </td>
            <td width="26%">
              <span matTooltip="{{ 'description' | translate }}: {{ line_item.description | placeholdWithString }}">
                {{ line_item.description | truncate | placeholdWithString }}
              </span>
            </td>
            <td width="12%" class="text-center">
              <span  matTooltip="{{ 'buy_price' | translate }}: {{ line_item.item_unit_cost | currency }}">
                {{ line_item.item_unit_cost | currency }}
              </span>
            </td>
            <td width="12%" class="text-center">
              <span  matTooltip="{{ 'unit_price' | translate }}: {{ line_item.item_unit_price | currency }}">
                {{ line_item.item_unit_price | currency }}
              </span>
            </td>
            <td width="20%" class="text-center">
              <span  matTooltip="{{ 'contract_unit_price' | translate }}: {{ line_item.contract_unit_price | currency }}">
                {{ line_item.contract_unit_price | currency }}
              </span>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-template #noRecordFound>
        <tr>
          <td colspan="5" class="text-center">
              {{ 'no_available_items' | translate }}
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</ng-template>